// Shared Firebase Storage folder for all documents of a company
export function companyStorageFolder (companyName) {
  const folderName = String(companyName).replace(/[/#?[\]*]/g, '-').trim()
  return `Companies/${folderName}`
}
